import { userRoles } from "@/apis"
import { USER_ROLES_REQUEST, USER_ROLES_SUCCESS, USER_ROLES_REQUEST_FAIL } from "../action-types/userRole"

// eslint-disable-next-line import/prefer-default-export
export const userGetRoles = (userId) => async (dispatch) => {
    dispatch({ type: USER_ROLES_REQUEST })
    try {
        const result = await userRoles(userId)
        dispatch({
            type: USER_ROLES_SUCCESS,
            payload: {
                userId,
                userRoles: result.data.userRoles,
                status: result.data.status,
            },
        })
    } catch (error) {
        dispatch({
            type: USER_ROLES_REQUEST_FAIL,
            payload: error.data ? error.data.message : error.message,
        })
    }
}
